import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const MobileStickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-50 px-4 pb-[max(1rem,env(safe-area-inset-bottom))] transition-all duration-300 md:hidden ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
      aria-hidden={!show}
    >
      <div className="mx-auto flex w-full max-w-md items-center justify-between gap-3 rounded-2xl border-2 border-blue-300 bg-white/95 px-4 py-3.5 shadow-2xl shadow-blue-300/50 backdrop-blur">
        <div className="flex min-w-0 flex-col leading-tight">
          <span className="text-[13px] font-black uppercase tracking-wide text-brand-black">30 enquiries in 30 days, or free</span>
          <span className="mt-1 text-[11px] font-bold uppercase tracking-wider text-brand-blue">$250/wk · No lock-in</span>
        </div>
        <Link
          to="/offer"
          className="inline-flex min-h-[44px] shrink-0 items-center justify-center rounded-xl bg-brand-blue px-4 py-2.5 text-xs font-black uppercase tracking-wider text-white shadow-lg shadow-blue-300/60 ring-1 ring-blue-700/20"
        >
          Check My Territory
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
